import * as CubiqTS from "../../../../../cubiq-model-multi-asset";
import { ICcyLookupService } from "shared/cubiq-services/lookup/model/ICcyLookupService";
import { BfxSysConfigUtilService } from "shared/auth-services";
export class NotificationGeneralHelper {
  constructor(
    private ccyPairLookup: ICcyLookupService,
    private sysConfigUtilService: BfxSysConfigUtilService,
  ) {}

  public instrumentHelper(order: CubiqTS.OrderDataImpl) {
    if (order.isInvertedOrderFg) {
      return order.nonBaseCode + "/" + order.baseCode;
    }
    return order.baseCode + "/" + order.nonBaseCode;
  }

  public amountHelper(amount: CubiqTS.BigNumber, fixedCode: string): string {
    if (amount) {
      let ccy = this.ccyPairLookup.getCcy(fixedCode);

      let amtStr: string = "";
      let decorator: string = "";
      if (ccy && CubiqTS.PositionUnit.Oz != ccy.positionUnitId) {
        amount = amount.dividedBy(1e6);
        amtStr = amount.toFormat(2);
        decorator = "m";
      } else {
        amtStr = amount.toFormat();
        decorator = "oz";
      }
      return amtStr + decorator;
    }
    return "-";
  }

  public opsInterventionExceptionTypeIdHelper(rate: any) {
    if (rate && rate.info && rate.info.opsException && rate.info.opsException.exceptionTypeId)
      return rate.info.opsException.exceptionTypeId;
    return null;
  }

  public dateToMomentHelper(adaptee: any, propertyName: string) {
    let dt: any = adaptee[propertyName];
    if (CubiqTS.moment.isMoment(dt)) {
      // TODO: offset conditions with TZ are lost over subjects
      // this reapplies tz offset conditions on a fresh moment instance
      return dt.utc().local();
    } else if (CubiqTS.Long.isLong(dt)) {
      // moment accepts unix milliseconds seconds in this format
      let dtM = CubiqTS.moment((dt as CubiqTS.Long).toNumber());
      return dtM;
    } else if (typeof dt === "string") {
      // FIXME: Cubiq-TS decode ISO string to moment
      // iso string from CUBIQTS miss decode
      // let dtM = moment(dt, "YYYY-MM-DD HH:mm:ss");

      let dtM = CubiqTS.moment(Number(dt));

      // TODO tz support- cubiq-ts is always UTC
      return dtM;
    } else if (dt && dt.toLocaleDateString) {
      return CubiqTS.moment(dt);
    } else if (dt && CubiqTS.moment.isMoment(dt)) {
      return dt;
    } else if (dt instanceof CubiqTS.StandardDateImpl) {
      return CubiqTS.moment([dt.year, dt.month - 1, dt.day]);
    }
    return null;
  }

  public isBuyHelper(item: any, propertyName: string): string {
    let isBuy = item[propertyName];
    if (isBuy !== undefined && isBuy !== null && typeof isBuy === "boolean") {
      if (isBuy) {
        return "Buy";
      } else {
        return "Sell";
      }
    }
    return "-";
  }

  public requestOrderTypeHelper(order: CubiqTS.OrderDataImpl | CubiqTS.DealImpl): string {
    if (order !== undefined && order != null) {
      let requestedOrderType =
        order instanceof CubiqTS.OrderDataImpl ? order.requestedOrderType : order.requestOrderType;
      let { executionType } = order;
      switch (requestedOrderType) {
        case CubiqTS.RequestOrderType.TP:
          return "TP ";
        case CubiqTS.RequestOrderType.CALL:
          let reqTypeString =
            executionType != null && executionType == CubiqTS.ExecutionType.MANUAL
              ? this.sysConfigUtilService.manualExecutionCallNameText
              : "CALL ";
          return reqTypeString;
        case CubiqTS.RequestOrderType.BMARK:
          return "BMARK ";
        case CubiqTS.RequestOrderType.SL_ASK:
          return "SL ASK ";
        case CubiqTS.RequestOrderType.SL_BID:
          return "SL BID ";
        case CubiqTS.RequestOrderType.SL_ATRATE:
          return "SL ";
        case CubiqTS.RequestOrderType.ALGO:
          return "ALGO ";
        case CubiqTS.RequestOrderType.TSL:
          return "TSL ";
        case CubiqTS.RequestOrderType.TSL_BID:
          return "TSL BID ";
        case CubiqTS.RequestOrderType.TSL_ASK:
          return "TSL ASK ";
        case CubiqTS.RequestOrderType.MARKET:
          return "MKT ";
      }
    }
  }
}
